import { vaultFetch } from './vault-api-core.ts'

export interface VaultBranchRuleRow {
  id: string
  rootId: string
  nodeId: string | null
  refPattern: string
  environments: string[]
  [key: string]: unknown
}

// ── branch rules ────────────────────────────────────────────────────────
export async function listBranchRules(
  rootId: string,
): Promise<VaultBranchRuleRow[]> {
  const { rules } = await vaultFetch<{ rules: VaultBranchRuleRow[] }>(
    `/vault/admin/${rootId}/branch-rules`,
  )
  return rules
}

export function addBranchRule(
  rootId: string,
  body: { nodeId: string | null; refPattern: string; environments: string[] },
): Promise<VaultBranchRuleRow> {
  return vaultFetch<VaultBranchRuleRow>(`/vault/admin/${rootId}/branch-rules`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function deleteBranchRule(rootId: string, id: string): Promise<void> {
  return vaultFetch<undefined>(`/vault/admin/${rootId}/branch-rules/${id}`, {
    method: 'DELETE',
  })
}
